/* eslint-disable @typescript-eslint/naming-convention */
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import {isMobileOrTabletByScreen} from 'core/helpers';

interface IProps {
    text: string;
}

export const FilterHint: FC<IProps> = ({text}) => {
    const isTabletOrMobile = isMobileOrTabletByScreen();
    return (
        <Tooltip
            className={style.tooltip}
            overlay={
                <span className={style.tooltipContent}>
                    <Typography variant={'label-14-r'}>{text}</Typography>
                </span>
            }
            positionStrategy={'fixed'}
            place={isTabletOrMobile ? 'top-start' : 'top'}
            onClick={(e) => e.stopPropagation()}
        >
            <Icon className={style.icon} icon={'hint'} />
        </Tooltip>
    );
};
